<template>
  <div id="box">
    <div class="inner">
      <h1 v-html="$t('authorization.title')" />
      <div class="tabWrappers" v-show="!isMobile">
        <Tab :tabType="'email'" :isSelected="true" />
        <Tab :tabType="'qrcode'" :isSelected="false" @tab="toQRCodePage" />
      </div>
      <div class="scrollWrapper">
        <p
          v-if="!dataLoading"
          v-html="$t('authorizationSelector.description')"
          class="description"
        />
        <p
          v-if="!dataLoading"
          v-html="$t('authorizationSelector.subtitle')"
          class="subtitle"
        />
        <ul v-if="!dataLoading" class="lists expandWrapper">
          <Email
            v-for="(email, index) in emailList"
            :key="index"
            :email="email"
            @select="authorization"
          />
        </ul>
        <div v-if="dataLoading" class="expandWrapper loading">
          <img
            v-svg-inline
            class="img loading"
            src="../assets/imgs/loadingWhite.svg"
            alt="loading"
          />
        </div>
      </div>
      <div class="wrapper">
        <CustomButton
          v-if="!dataLoading"
          :buttonType="'primary'"
          :customButtonTxt="$t('customButton.otherMails')"
          @submit="toEnterMailPage"
        />
        <a
          href="https://x-id.me/"
          target="_blank"
          v-html="$t('authorization.noAccount')"
          class="companyLink"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
import Email from "../components/email.vue";
import Tab from "../components/tab.vue";
import { isMobileOnly } from "mobile-device-detect";

export default {
  name: "SelectEmail",
  components: {
    CustomButton,
    Email,
    Tab,
  },
  data() {
    return {
      dataLoading: false,
      emailList: [],
    };
  },
  computed: {
    isMobile() {
      return isMobileOnly == true;
    },
  },
  methods: {
    toEnterMailPage() {
      this.$emit("navigate", { page: "EnterEmail", errorType: "" });
    },
    authorization(val) {
      this.dataLoading = true;
      this.$emit("authorization", val);
    },
    toQRCodePage() {
      this.$emit("navigate", { page: "QRCodeAuthorization", errorType: "" });
    },
  },
  mounted() {
    this.emailList = JSON.parse(localStorage.getItem("emails"));
    if (this.emailList == null || this.emailList.length == 0) {
      this.toEnterMailPage();
      return;
    }
  },
};
</script>

<style lang="sass" scoped>
#box
  .inner
    height: 100%
    .lists
      padding: 2px
      box-sizing: border-box
      li.emailWrapper
        &:last-child
          margin-bottom: 0px !important
      &.hide
        display: none
    .expandWrapper.loading
      +flex()
    .wrapper
      margin-top: 12px
</style>